import { ABOUT_US, CLUBHOUSE, EVENTS, HOME, SUBMIT_SCORECARD } from './Paths'
import { OFFER_URL } from './Values'

export enum NavigationId {
  Home = 'home',
  AboutUs = 'aboutUs',
  Memberships = 'memberships',
  Events = 'events',
  Clubhouse = 'clubhouse',
  SubmitScorecard = 'submitScorecard',
}

export const HEADER_HEIGHT_PX = {
  DESKTOP: 96,
  MOBILE: 150,
}

export type Navigation = {
  id: NavigationId
  path: string
  label: string
}

export const NAVIGATION_BASE: Navigation[] = [
  { id: NavigationId.Home, path: HOME, label: 'Home' },
  { id: NavigationId.AboutUs, path: ABOUT_US, label: 'About Us' },
  { id: NavigationId.Memberships, path: OFFER_URL, label: 'Memberships' },
  { id: NavigationId.Events, path: EVENTS, label: 'Events' },
]

export const NAVIGATION_DROPDOWN: Navigation[] = [
  { id: NavigationId.Clubhouse, path: CLUBHOUSE, label: 'Recent News' },
  {
    id: NavigationId.SubmitScorecard,
    path: SUBMIT_SCORECARD,
    label: 'Submit Scorecard',
  },
]
